module.exports = __webpack_public_path__ + "static/media/gymate2.8d2b86ad.gif";